import { enumHorzCentering, enumVertCentering, kSmallIcon, overlayIconMapping } from "../constants";
import { doDrawIcon } from "../utils/doDrawIcon";
import { QBoxOverlay } from "./QBoxOverlay";
import { RoundTo3 } from "../utils/RoundTo3";
import { XML_Param5 } from "../utils/XML_Param5";
import { XML_Scale } from "../utils/XML_Scale";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";

export class QBoxOverlay_AppIcon extends QBoxOverlay {
  constructor() {
    super();
    this.fDeltaDefX = -6;
    this.fDeltaDefY = -8;
    this.fVPosition = enumVertCentering.pinBottom;
    this.fHPosition = enumHorzCentering.pinRight;
    this.imageRef = 0;
    this.overlayType = null;
  }

  Init(wsMgr) {
    this.fImageMgr = wsMgr.fImageMgr;
  }

  InitBoxOverlay(chartBox) {
    super.InitBoxOverlay(chartBox);
    const imageIndex = this.determineIconForBoxType();
    this.fEnabledImage = this.fImageMgr.GetIndexImage(imageIndex);
  }

  determineIconForBoxType() {
    let imageIndex = this.imageRef;

    if (this.fChartBox && overlayIconMapping && this.overlayType) {
      const isPositionDoc = this.fChartBox.GetDoc().IsPositionDocument();
      const boxType = isPositionDoc ? "position" : "employee";
      const iconMapping = overlayIconMapping[boxType];

      if (iconMapping && iconMapping[this.overlayType] !== undefined) {
        imageIndex = iconMapping[this.overlayType];
      }
    }

    return imageIndex;
  }

  getExportIconType() {
    if (!this.fChartBox || !this.overlayType) return this.overlayType;

    const isPositionDoc = this.fChartBox.GetDoc().IsPositionDocument();
    return isPositionDoc ? `position-${this.overlayType}` : this.overlayType;
  }

  DoRenderElement(drawBuffer) {
    const ctx = drawBuffer.getContext("2d");
    const iconImage = this.fEnabledImage;
    const size = this.fIconSize ?? 24;
    doDrawIcon(
      ctx,
      iconImage,
      0,
      0,
      iconImage.width,
      iconImage.height,
      this.fHorzOffset + this.fDeltaDefX,
      this.fVertOffset,
      size,
      size,
      true
    );
  }

  drawPPTIcon(x0, y0, altCanvasElement, layer) {
    const scaledIconSize = Math.round(XML_Scale(kSmallIcon.imageWidth, altCanvasElement, layer));
    XML_Param5(
      "icn",
      this.getExportIconType(),
      RoundTo3(x0),
      RoundTo3(y0),
      RoundTo3(scaledIconSize),
      RoundTo3(scaledIconSize),
      altCanvasElement
    );
  }

  getPPTCoordinates(x, y, altCanvasElement, layer) {
    const isPositionDoc = this.fChartBox.GetDoc().IsPositionDocument();
    const offset = 5;

    if (isPositionDoc) {
      return {
        x0: XML_ScaleAndShiftX(x - offset, altCanvasElement, layer),
        y0: XML_ScaleAndShiftY(y - offset, altCanvasElement, layer)
      };
    } else {
      const scaledIconSize = Math.round(XML_Scale(kSmallIcon.imageWidth, altCanvasElement, layer));
      return {
        x0: XML_ScaleAndShiftX(x + offset, altCanvasElement, layer) - scaledIconSize / 2,
        y0: XML_ScaleAndShiftY(y, altCanvasElement, layer)
      };
    }
  }
}
